import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import "./modal.css";
export const GenericModal = ({
  isOpen,
  onClose,
  children,
  title,
  onClickHandler,
  loadingButton,
  buttonText,
  scroll = true,
  buttonShow,
}: any) => {
  return (
    <>
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        size="xl"
        motionPreset="scale"
        scrollBehavior={scroll ? "inside" : "outside"}
        isCentered
      >
        <ModalOverlay
          bg="none"
          backdropFilter="auto"
          backdropInvert="30%"
          backdropBlur="2px"
        />
        <ModalContent
          minW={[
            "360px", // base
            "470px", // 480px upwards
            "760px", // 768px upwards
            "800px", // 992px upwards
          ]}
          maxW={[
            "360px", // base
            "470px", // 480px upwards
            "760px", // 768px upwards
            "800px", // 992px upwards
          ]}
          borderRadius="10px"
        >
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody pb="4">{children}</ModalBody>
          {buttonShow && (
            <ModalFooter>
              <HStack spacing={"24px"}>
                <Button
                  colorScheme="buttonPrimary"
                  onClick={onClickHandler}
                  isDisabled={loadingButton}
                  isLoading={loadingButton}
                >
                  {buttonText}
                </Button>
                <Button onClick={onClose} isDisabled={loadingButton}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
